<template lang="pug">
  div#preloader
    vue-progress-bar
    bounce-spinner
    //- AutoType
    div.healty-browser
      p.type
        AutoType(:str="'This site works better in modern browsers'", :delay='0', :typeSpeed="40", :cleanCursor="true")
        AutoType(:str="' - like Chrome 🤘 '", :delay='1950', :typeSpeed="40", :cleanCursor="true" v-on:done="typeDone")
</template>


<script>
  import AutoType from '@/components/AutoType.vue'

  export default {
    name: 'Preloader',

    components: { AutoType },

    methods: {
      typeDone () {
        // End preloading
        this.$Progress.finish()
        setTimeout(() => {
          this.$parent.preloading = false
          // Begin splash animations
          this.$parent.beginAnimations()
        }, 1)
      }
    },

    created () {
      // Start VueProgressBar
      this.$Progress.start()
    },

    mounted () {
      // Disable scrolling
      document.querySelector('html').style.overflowY = 'hidden'
    },

    beforeDestroy () {
      setTimeout(() => {
        // Enable scrolling
        document.querySelector('html').style.overflowY = 'visible'
      }, 1700)
    }

  }
</script>


<style lang="sass" scoped>
  #preloader
    background-color: $BackgroundColor
    z-index: 1001
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    display: flex
    justify-content: center
    align-items: center

    > .healty-browser
      flex-direction: column
      align-self: flex-end
      justify-content: flex-start
      padding: 2rem 0

      > p.type
        color: $Gray81
        font-size: .625rem
        letter-spacing: 0.05em
        // Responsive
        +breakpoint(sm)
          font-size: .7625rem
        +breakpoint(lg)
          font-size: .8625rem
</style>




<style lang="scss">
  /* vue-progressbar */
  .__cov-progress {
    position: absolute!important;
    // background: linear-gradient(330deg, #360670 0%, #db0768 25%, #e23b4a 50%, #faaa54 75%, #23966c 100%)!important;
    background: linear-gradient(to right, #F55D07, #F3BF00)!important;
    height: 0.4em!important;
  }
  /* vue-spinner */
  .v-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/core/Preloader.vue